import { type Cell } from 'react-table';
import { WorkspaceObjectType } from '@/enums/workspace';
import type {
  IWorkspaceFileItem,
  IWorkspaceFolderItem,
  WorkspaceObjectItem,
} from '@/types/workspace.table';
import { FileActionsContextMenu } from './FileActionsContextMenu';
import { FolderActionsContextMenu } from './FolderActionsContextMenu';

export function ActionsCell(props: Cell<WorkspaceObjectItem>) {
  switch (props.row.original.object.typeId) {
    case WorkspaceObjectType.File: {

      return (
        <FileActionsContextMenu data={props.row.original as IWorkspaceFileItem} />
      );
    }

    case WorkspaceObjectType.Folder:
      return <FolderActionsContextMenu data={props.row.original as IWorkspaceFolderItem} />;

    case WorkspaceObjectType.ProjectParent:
      //return <ProjectActionsCell {...(props)} />;
      return null;

    case WorkspaceObjectType.CallTranscript:
      //return <TranscriptActionsCell {...(props as Cell<IWorkspaceTranscriptItem>)} />;
      return null;

    case WorkspaceObjectType.Brand:
    case WorkspaceObjectType.Workspace:
      return null;

    default:
      throw new UnreachableCaseError(props.row.original.object.typeId);
  }
}

/*
function TranscriptActionsCell({ row: { original: data } }: Cell<IWorkspaceTranscriptItem>) {
  const isInternalUser = useIsInternalUser();

  const access: WorkspaceTranscriptAccess = useMemo(() => ({
    canAccessRecording: isInternalUser || canAccessRecording(data.transcript?.settings?.publishType),
    canAccessTranscription: isInternalUser || canAccessTranscription(data.transcript?.settings?.publishType),
    canManageAccess: data.capabilities.canManageAccess,
    canMove: data.capabilities.canMove,
    canRename: data.capabilities.canRename,
  }), [
    data.capabilities,
    data.transcript?.settings?.publishType,
    isInternalUser,
  ]);

  const isDownloadable = isInternalUser || data.transcript.enhancement?.statusId === TranscriptionRevisionStatus.Completed;

  if (!isDownloadable) return null;

  return (
    <WorkspaceTranscriptAccessContext.Provider value={access}>
      <CallTranscriptWorkspaceActionsContainer object={data.object} transcript={data.transcript}>
        <TranscriptContextMenuPopper transcriptId={data.transcript.id} />
      </CallTranscriptWorkspaceActionsContainer>
    </WorkspaceTranscriptAccessContext.Provider>
  );
}
  */

/*
function canAccessRecording(typeId: TranscriptPublishType) {
  return typeId === TranscriptPublishType.RecordingAndTranscript
    || typeId === TranscriptPublishType.RecordingOnly;
}

function canAccessTranscription(typeId: TranscriptPublishType) {
  return typeId === TranscriptPublishType.RecordingAndTranscript
    || typeId === TranscriptPublishType.TranscriptOnly;
}
*/